module.exports = __webpack_public_path__ + "img/3_129.ff804782.png";